import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity,
} from '../../utils/auth';
import { getItem } from '../../utils/localStorageFn';
import { injectScript } from '../register/hook';

const accessKeyFlow = () => {
  const history = useHistory();

  const validateAccessKey = ({
    accessKey,
    changeModalText,
    setShowModal,
    changeResponseMessage,
  }) => {
    const publisherData = JSON.parse(getItem('publisherdata'));
    const publisherId = publisherData.id;
    const userData = JSON.parse(getItem('userdata'));
    const { accessToken } = userData;

    setShowModal(true);
    changeModalText('verifying your access key...');

    (async () => {
      try {
        const payload = {
          accessKey,
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/publisher/${publisherId}/validateAccessKey`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const json = await response.json();
        const { message, success } = json;

        if (success) {
          setAuthToken(userData.accessToken);
          setRefreshToken(userData.refreshToken);
          setDeviceIdentity(userData.deviceKey);

          setShowModal(false);
          const isLoginFlow = JSON.parse(getItem('isloginflow'));
          if (!isLoginFlow) {
            history.push('/registerpricing');
          } else {
            await injectScript(history);
          }
        } else {
          setShowModal(false);
          changeResponseMessage("Sorry, Access Key is not valid.");
        }
      } catch (e) {
        setShowModal(false);
        toast.error(e.message);

        removeAuthToken();
        removeRefreshToken();
        removeDeviceIdentity();

        console.log(e);
      }
    })();
  };

  return validateAccessKey;
};

export default accessKeyFlow;
